import React from 'react';
import ImportSteps from "v4/pages/admin/Import/components/ImportSteps/ImportSteps";
import ImportContextProvider from "v4/pages/admin/Import/contexts/ImportContext";
import ErrorBoundary from "components/Error/errorBoundary";
import "./ImportPage.scss";

export default function ImportPage() {
    return (
        <ErrorBoundary>
            <ImportContextProvider>
                <ImportSteps/>
            </ImportContextProvider>
        </ErrorBoundary>
    )
}
